require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-08-23-email-is-awesome.json") })
        }
      }, "path---articles-2009-08-23-email-is-awesome");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-08-23-email-is-awesome!./.cache/json/articles-2009-08-23-email-is-awesome.json
// module id = 575
// module chunks = 231608221292675